/* ============================================================================
   theme-tracker.js v2 — Tracker comportemental DIY (Jourdan / Eurus)
   ----------------------------------------------------------------------------
   "Contentsquare maison" : clics enrichis, rage-clicks, dead-clicks, profondeur
   de scroll, visibilité de sections — autocapture (sélecteur + texte) — envoyés
   au Worker existant /collect -> BigQuery `events` (event_type='dom').

   v2 : intègre la revue de 3 agents (front / perf / data).
   - Perf : textContent (pas innerText/reflow) ; résolution déportée en idle ;
     viewport mis en cache ; un seul MutationObserver permanent childList.
   - Sûreté : try/catch partout ; clearInterval au pagehide ; observateur pur.
   - Data : client_id partagé via cookie jrd_cid ; scroll% -> element_value ;
     section id -> element_id ; id d'event stable (dédup) ; tagName minuscule.
   - RGPD : consent-gated ; jamais la valeur des champs ; masquage PII (email/tel).
   ========================================================================== */
(function () {
  'use strict';
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.__jrdTrackerOn) return; window.__jrdTrackerOn = true;
  } catch (e) { return; }

  var ENDPOINT = 'https://collect.jourdan-bijoux.com/collect?k=jrd_a7f3c91e8b2d4056af1c9e3b7d240568';
  var seq = 0, Q = [], VW = 0, VH = 0, moCount = 0, flushTimer = null;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };

  try { VW = window.innerWidth; VH = window.innerHeight; } catch (e) {}

  /* ---- client_id partagé (jr_cid posé par le pixel à terme, sinon _shopify_y) ---- */
  function setCookie(n, v) { try { document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;max-age=31536000;SameSite=Lax'; } catch (e) {} }
  function getId() {
    try {
      var j = document.cookie.match(/(?:^|;\s*)jrd_cid=([^;]+)/); if (j) return decodeURIComponent(j[1]);
      var s = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
      if (s) { var v = decodeURIComponent(s[1]); setCookie('jrd_cid', v); return v; }
      var k = null; try { k = localStorage.getItem('jrd_cid'); } catch (e) {}
      if (!k) { k = 'jrd-' + Math.random().toString(36).slice(2) + Date.now().toString(36); try { localStorage.setItem('jrd_cid', k); } catch (e) {} }
      setCookie('jrd_cid', k); return k;
    } catch (e) { return null; }
  }
  var CID = getId();

  function consentOk() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp) return false;
      if (typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
      if (typeof cp.userCanBeTracked === 'function') return !!cp.userCanBeTracked();
      return false;
    } catch (e) { return false; }
  }

  /* ---- helpers d'identification (autocapture) ---- */
  function sel(el) {
    try {
      if (!el || el === document || !el.tagName) return null;
      if (el.id) return el.tagName.toLowerCase() + '#' + el.id;
      var c = el.getAttribute && el.getAttribute('class');
      c = (typeof c === 'string') ? c.trim().split(/\s+/).slice(0, 2).join('.') : '';
      return el.tagName.toLowerCase() + (c ? '.' + c : '');
    } catch (e) { return null; }
  }
  function txt(el) {
    try {
      if (!el || !el.tagName) return null;
      var tag = el.tagName.toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') {
        return (el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.getAttribute('name') || el.type || '').slice(0, 80);
      }
      if (tag === 'img') {
        return (el.getAttribute('alt') || (el.currentSrc || el.getAttribute('src') || '').split('?')[0].split('/').pop() || 'image').slice(0, 80);
      }
      var s = (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80); // textContent => pas de reflow
      // anti-PII ciblé : masque uniquement les vrais emails et numéros de tél (>=8 chiffres),
      // PAS les prix/références produit (peu de chiffres) -> on garde le nom des produits.
      if (/[^\s@]+@[^\s@]+\.[^\s@]{2,}/.test(s)) return '[email masqué]';
      // téléphone uniquement (0X + 9 chiffres FR, ou +indicatif) — n'attrape PAS les prix ni les références produit
      if (/(?:^|[^\d+])(?:0[1-9](?:[ .\-]?\d){8}|\+\d{1,3}(?:[ .\-]?\d){8,})(?:$|[^\d])/.test(s)) return '[tel masqué]';
      return s;
    } catch (e) { return null; }
  }
  function section(el) {
    try { var s = el && el.closest && el.closest('.shopify-section[id], [data-section-type], section'); return s ? (s.id || s.getAttribute('data-section-type') || 'section') : null; }
    catch (e) { return null; }
  }
  // "vraiment cliquable ?" : liens/boutons OU handler Alpine @click / role / cursor-pointer (menus, accordéons)
  function intendedClickable(el) {
    var n = el, i = 0;
    while (n && n.nodeType === 1 && i < 6) {
      try {
        if (n.matches && n.matches('a,button,[role="button"],input,select,textarea,label,[data-track],[onclick],[type="submit"],.add_to_cart_button,.cursor-pointer')) return true;
        if (n.attributes) { for (var a = 0; a < n.attributes.length; a++) { var an = n.attributes[a].name; if (an === 'onclick' || an.indexOf('@click') === 0 || an.indexOf('x-on:click') === 0) return true; } }
      } catch (e) {}
      n = n.parentElement; i++;
    }
    return false;
  }

  // over = surcharge de data.element (ex. {id:..., value:...}) pour scroll/section
  function build(name, el, extras, over) {
    var e = {};
    try {
      var elem = el ? {
        id: (el.getAttribute && el.getAttribute('data-track')) || null,
        tagName: el.tagName ? el.tagName.toLowerCase() : null,
        href: (el.getAttribute && el.getAttribute('href')) || null,
        type: sel(el),
        value: txt(el)
      } : {};
      if (over) { for (var k in over) elem[k] = over[k]; }
      e = {
        id: (CID || 'a') + '-' + (++seq) + '-' + Date.now(),     // id stable -> dédup Worker
        name: name, type: 'dom', timestamp: new Date().toISOString(), clientId: CID, seq: seq,
        context: {
          document: { location: { href: location.href, pathname: location.pathname, search: location.search }, referrer: document.referrer, title: document.title },
          navigator: { userAgent: navigator.userAgent, language: navigator.language },
          window: { innerWidth: VW, innerHeight: VH }
        },
        data: { element: elem, extras: extras || {} }
      };
    } catch (err) {}
    return e;
  }

  function queue(ev) { if (ev && ev.name && Q.length < 200) Q.push(ev); }

  function sendOne(ev) {
    var body = JSON.stringify({ e: ev, c: true });
    try { if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, body)) return; } catch (e) {}
    try { fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' } }).catch(function () {}); } catch (e) {}
  }
  function flush() {
    try {
      if (!consentOk()) { if (Q.length >= 200) Q.length = 0; return; }
      if (!Q.length) return;
      var batch = Q.splice(0, Q.length);
      for (var i = 0; i < batch.length; i++) sendOne(batch[i]);
    } catch (e) {}
  }

  function attach() {
    try {
      // garantir le chargement de l'API de consentement dans le contexte thème (sinon consentOk reste false)
      try { if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (e) {}
      try { document.addEventListener('visitorConsentCollected', function () { flush(); }); } catch (e) {}
      try { addEventListener('resize', function () { VW = window.innerWidth; VH = window.innerHeight; }, { passive: true }); } catch (e) {}

      // 1 seul MutationObserver permanent, childList only (dead-click via compteur)
      try { new MutationObserver(function (m) { moCount += m.length; }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}

      // CLICS : capture minimale synchrone, résolution en idle (protège l'INP). Observateur pur.
      var hist = [];
      document.addEventListener('click', function (ev) {
        try {
          var t = ev.target; if (!t || !t.closest) return;
          var interactive = t.closest('a,button,[role="button"],input,select,textarea,label,[data-track],[onclick],[type="submit"],.add_to_cart_button');
          var el = interactive || t;
          var now = Date.now(), x = ev.clientX, y = ev.clientY;
          hist.push({ t: now, x: x, y: y });
          hist = hist.filter(function (c) { return now - c.t < 800; });
          var near = hist.filter(function (c) { return Math.abs(c.x - x) < 30 && Math.abs(c.y - y) < 30; });
          var rage = near.length, isRage = rage >= 3;
          idle(function () { try { var sc = section(el); if (isRage) queue(build('rage_click', el, { clickCount: rage, x: x, y: y, section: sc })); queue(build('rich_click', el, { x: x, y: y, section: sc })); } catch (e) {} });
          if (!intendedClickable(el)) {
            var c0 = moCount, url = location.href;
            setTimeout(function () { if (moCount === c0 && location.href === url) idle(function () { try { queue(build('dead_click', el, { x: x, y: y, section: section(el) })); } catch (e) {} }); }, 700);
          }
        } catch (e) {}
      }, true);

      // SCROLL : passif + throttle 400ms, jalons une fois chacun. element_value = %.
      var maxPct = 0, marks = {}, pend = false;
      window.addEventListener('scroll', function () {
        try {
          if (pend) return; pend = true;
          setTimeout(function () {
            pend = false;
            try {
              var h = document.documentElement.scrollHeight - VH;
              var pct = h > 0 ? Math.min(100, Math.round((window.scrollY / h) * 100)) : 100;
              if (pct > maxPct) maxPct = pct;
              [25, 50, 75, 90, 100].forEach(function (m) { if (maxPct >= m && !marks[m]) { marks[m] = 1; queue(build('scroll_depth', null, { pct: m }, { value: String(m) })); } });
            } catch (e) {}
          }, 400);
        } catch (e) {}
      }, { passive: true });

      // SECTIONS : IntersectionObserver. element_id = id de section (colonne, pas JSON).
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.5) {
              var sid = en.target.id || (en.target.getAttribute && en.target.getAttribute('data-track')) || null;
              queue(build('section_view', null, { section: sid, ratio: Math.round(en.intersectionRatio * 100) }, { id: sid, value: null }));
              try { io.unobserve(en.target); } catch (e) {}
            }
          });
        }, { threshold: [0.5] });
        // on ignore les sections "chrome" toujours visibles (bandeau, header, menu, footer, badges) = bruit
        var CHROME = /announcement-bar|__header|mobile-navigation|menu-drawer|__footer|product-labels-and-badges|cart-drawer|cookie|popup|predictive-search/i;
        document.querySelectorAll('.shopify-section[id], [data-track^="section:"]').forEach(function (s) { if (s.id && CHROME.test(s.id)) return; io.observe(s); });
      } catch (e) {}

      // FLUSH : périodique (handle conservé) + au départ de page.
      flushTimer = setInterval(flush, 3000);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
      window.addEventListener('pagehide', function () { try { clearInterval(flushTimer); } catch (e) {} flush(); });
    } catch (e) {}
  }

  function start() { idle(attach, { timeout: 3000 }); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
